<template>
  <div>
    <nurse-detail
      fetchClinicsBy="admin"
      :canDelete="true"
      :adminApprovalVar="true"/>
  </div>
</template>

<script>

import nurseDetail from '../../components/nurses/nurseDetail.vue';

export default {
  components: {
      nurseDetail,
  },
  data:()=>({
  }),
};
</script>
